import { Component, Vue } from "vue-property-decorator";

import Cookies from 'js-cookie';
import { Loading, Nav, Hint, LightBoxResetPwd } from "@/components";
import { StoreUserModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Store, Common } from "@/constant";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";
import { UserInfo } from "@/types/Login";
import { Util } from "@/util";
import { Encrypt } from "@/util/Encrypt";

@Component<StoreUserEditController>({
    components: {
        Loading,
        Nav,
        Hint,
        LightBoxResetPwd,
    }
})
export default class StoreUserEditController extends Vue {
    private isLoading = true;

    private expireTime = 0;
    private accountTypeMap = Store.AccountTypeMap;
    private storeUserInfo = TCBReceiptApi.Protobuf.StoreUser.create();
    private selectMap: { [key: string]: TCBReceiptApi.Protobuf.IStoreList } = {};
    private isUser = false;

    /* 權限 */
    private tidNumberPermission: {
        sn: string;
        tidNumber: string;
        allSelected: boolean;
        storeList: {
            id: number;
            code: string;
            name: string;
            selected: boolean;
        }[];
        show: boolean;
    } = {
            sn: "",
            tidNumber: "",
            allSelected: false,
            storeList: [],
            show: false
        };

    private originPermissionMap: {
        [key: string]: {
            storeList: {
                susId?: number;
                id: number;
                code: string;
                name: string;
                selected: boolean;
            }[];
        };
    } = {};

    private groupPermissionList: {
        sn: string;
        tidNumber: string;
        allSelected: boolean;
        storeList: {
            id: number;
            code: string;
            name: string;
            selected: boolean;
        }[];
        show: boolean;
    }[] = [];    

    // 送出時
    private selectedStoreRadio = 0;
    private selectedTidNumberCheckbox: number[] = [];
    /* 權限 */

    /* Reset pwd */
    private lightboxResetPwd: {
        show: boolean,
        ori: string,
        new: string,
        err: boolean,
    } = {
            show: false,
            ori: "",
            new: "",
            err: false,
        }
    /* Reset pwd */

    // Hint
    private isDone = false;
    private isChange = false;
    private isResetPwd = false;
    private hintBox: { show: boolean, hint: string } = { show: false, hint: "" };

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        this.isLoading = true;

        if (!this.isUser) {
            const item = TCBReceiptApi.Protobuf.StoreUser.create({
                storeUserId: parseInt(this.$route.query.id as string),
            });
            const storeUser = TCBReceiptApi.Protobuf.StoreUser.encode(item).finish();
            await StoreUserModel.getById(storeUser);
            this.storeUserInfo = StoreUserModel.getSpecificStoreUser();
            console.log(this.storeUserInfo);
        }

        this.initPermission(); // 依帳號類型初始化對應權限
        this.isLoading = false;
        return false;
    }

    private initPermission() {
        const type = this.storeUserInfo.type as number; // 帳號類型
        switch (type) {
            case 1: {
                this.tidNumberPermission.sn = "0001";
                this.tidNumberPermission.tidNumber = this.storeUserInfo.tidNumber;
                this.tidNumberPermission.storeList = [];

                let isSelectedCount = 0;
                Object.keys(this.storeUserInfo.selectMap).forEach(storeCodeKey => {
                    const storeUserPermissionList = this.storeUserInfo.selectMap[storeCodeKey] as TCBReceiptApi.Protobuf.StoreUserPermissionList;
                    if (storeUserPermissionList && storeUserPermissionList.list.length > 0) {
                        storeUserPermissionList.list.forEach(store => {
                            let isSelected = false;
                            const permissionList = this.storeUserInfo.permission[storeCodeKey];
                            if (permissionList && permissionList.list) {
                                const isExist = permissionList.list.find(permissionStore => permissionStore.storeId === store.storeId);
                                if (isExist) {
                                    isSelected = true;
                                    isSelectedCount++;
                                }
                            }

                            const item = {
                                id: store.storeId as number,
                                code: store.storeCode as string,
                                name: store.registerName as string,
                                selected: isSelected,
                            };
                            this.tidNumberPermission.storeList.push(item);
                        });
                    }
                });

                this.tidNumberPermission.allSelected = (this.tidNumberPermission.storeList.length === isSelectedCount) ? true : false;
                this.tidNumberPermission.show = true;

                // 權限轉換成狀態
                this.tidNumberPermission.storeList.forEach((store, index) => {
                    if (store.selected) {
                        this.selectedStoreRadio = index;
                    }
                });

                console.log(this.tidNumberPermission);
                break;
            }
            case 2: { // 統編帳號
                this.tidNumberPermission.sn = "0001";
                this.tidNumberPermission.tidNumber = this.storeUserInfo.tidNumber;
                this.tidNumberPermission.storeList = [];

                let isSelectedCount = 0;
                Object.keys(this.storeUserInfo.selectMap).forEach(storeCodeKey => {
                    const storeUserPermissionList = this.storeUserInfo.selectMap[storeCodeKey] as TCBReceiptApi.Protobuf.StoreUserPermissionList;
                    if (storeUserPermissionList && storeUserPermissionList.list.length > 0) {
                        storeUserPermissionList.list.forEach(store => {
                            let isSelected = false;
                            const permissionList = this.storeUserInfo.permission[storeCodeKey];
                            if (permissionList && permissionList.list) {
                                const isExist = permissionList.list.find(permissionStore => permissionStore.storeId === store.storeId);
                                if (isExist) {
                                    isSelected = true;
                                    isSelectedCount++;
                                }
                            }

                            const item = {
                                id: store.storeId as number,
                                code: store.storeCode as string,
                                name: store.registerName as string,
                                selected: isSelected,
                            };
                            this.tidNumberPermission.storeList.push(item);
                        });
                    }
                });

                this.tidNumberPermission.allSelected = (this.tidNumberPermission.storeList.length === isSelectedCount) ? true : false;
                this.tidNumberPermission.show = true;

                // 權限轉換成狀態
                this.tidNumberPermission.storeList.forEach((store, index) => {
                    if (store.selected) {
                        this.selectedTidNumberCheckbox.push(index);
                    }
                });

                break;
            }
            case 3: { // 群組帳號
                this.groupPermissionList = []; // init

                Object.keys(this.storeUserInfo.selectMap).forEach(storeCodeKey => {
                    const storeList: {
                        id: number;
                        code: string;
                        name: string;
                        selected: boolean;
                    }[] = [];

                    const storeUserPermissionList = this.storeUserInfo.selectMap[storeCodeKey] as TCBReceiptApi.Protobuf.StoreUserPermissionList;
                    if (storeUserPermissionList && storeUserPermissionList.list.length > 0) {
                        let isSelectedCount = 0;
                        storeUserPermissionList.list.forEach(store => {
                            let isSelected = false;
                            const permissionList = this.storeUserInfo.permission[storeCodeKey];
                            if (permissionList && permissionList.list) {
                                const isExist = permissionList.list.find(permissionStore => permissionStore.storeId === store.storeId);
                                if (isExist) {
                                    isSelected = true;
                                    isSelectedCount++;
                                }
                            }

                            const item = {
                                id: store.storeId as number,
                                code: store.storeCode as string,
                                name: store.registerName as string,
                                selected: isSelected,
                            };
                            storeList.push(item);
                        });

                        const nextLen = this.groupPermissionList.length + 1;
                        const sn = ("0000" + nextLen.toString()).substring(nextLen.toString().length);
                        const value = {
                            sn: sn,
                            tidNumber: storeCodeKey,
                            allSelected: (storeList.length === isSelectedCount) ? true : false,
                            storeList: storeList,
                            show: true,
                        };
                        this.groupPermissionList.unshift(value);
                    }
                });
                break;
            }
            case 4: break;
            default:
                this.openHint("帳號類型錯誤");
        }

        console.log(this.tidNumberPermission);
    }

    private async submit() {
        console.log("submit");
        console.log("radio");
        console.log(this.selectedStoreRadio);
        console.log("checkbox");
        console.log(this.selectedTidNumberCheckbox);

        // 重設密碼指定信箱格式驗證
        if (this.storeUserInfo && this.storeUserInfo.resetMail !== '') {
            const isValidate = Util.validateEmail(this.storeUserInfo.resetMail);
            if (!isValidate) {
                this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.ValidateEmail]);
                return false;
            }
        }

        // 更新權限
        if (!this.isUser && this.storeUserInfo.type !== 1) {
            if (this.storeUserInfo.type === 2 && this.selectedTidNumberCheckbox.length === 0) {
                this.openHint("請選取特店");
                return false;
            }

            // 權限轉換成勾選狀態
            // if (this.storeUserInfo.type === 1) {
            //     this.tidNumberPermission.storeList[this.selectedStoreRadio].selected = true;
            //     this.tidNumberPermission.storeList.forEach((store, index) => {
            //         this.tidNumberPermission.storeList[index].selected = (this.selectedStoreRadio === index) ? true : false;
            //     });
            // } else 
            if (this.storeUserInfo.type === 2) {
                this.tidNumberPermission.storeList.forEach((store, index) => {
                    this.tidNumberPermission.storeList[index].selected = (this.selectedTidNumberCheckbox.some(checkboxIndex => checkboxIndex === index)) ? true : false;
                });
            }
    
            /* 加入權限 */
            console.log("目前的 tidNumberPermission");
            console.log(this.tidNumberPermission);
    
            // if (this.storeUserInfo.type === 1 || this.storeUserInfo.type === 2) {
            if (this.storeUserInfo.type === 2) {
                const permission: { [storeCode: string]: TCBReceiptApi.Protobuf.StoreUserPermissionList } = {}; // 以特店代號為索引的map
                const storeUserPermissionList = TCBReceiptApi.Protobuf.StoreUserPermissionList.create();
        
                this.tidNumberPermission.storeList.forEach(thisStore => {
                    if (thisStore.selected) {
                        // 使用者選擇的特店資訊
                        const storeUserPermission = TCBReceiptApi.Protobuf.StoreUserPermission.create({
                            storeId: thisStore.id as number,
                            storeCode: thisStore.code as string,
                            tidNumber: this.tidNumberPermission.tidNumber as string,
                            registerName: thisStore.name as string,
                        });
        
                        // 權限陣列
                        storeUserPermissionList.list.push(storeUserPermission);
                    }
                });
        
                // 帳號權限
                permission[this.tidNumberPermission.tidNumber] = storeUserPermissionList;
                this.storeUserInfo.permission = permission;
            } else if (this.storeUserInfo.type === 3) {
                this.putPermissionListInList();
            }
            /* 加入權限 */
        }

        // send value
        const item = TCBReceiptApi.Protobuf.StoreUser.create(this.storeUserInfo);
        item.motify = TCBReceiptApi.Protobuf.StoreUserMotify.create();
        item.tidNumber = this.tidNumberPermission.tidNumber as string;

        console.log("item");
        console.log(item);

        const storeUser = TCBReceiptApi.Protobuf.StoreUser.encode(item).finish();
        const errorCode = await StoreUserModel.editStoreUser(storeUser);
        this.isLoading = false;

        console.log("errorCode");
        console.log(errorCode);
        if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
            this.isDone = true;
        }

        this.openHint(Common.ErrorCodeMap[errorCode]);
    }

    /* Reset pwd */
    private openLightboxResetPwd() {
        this.lightboxResetPwd.show = true;
        this.lightboxResetPwd.err = false;
    }

    private closeLightboxResetPwd() {
        this.lightboxResetPwd.show = false;
    }

    private async submitLightboxResetPwd(info: { [k: string]: string }) {
        console.log("submitLightboxResetPwd");
        console.log(info);

        this.lightboxResetPwd.show = false;

        // valid ori pwd
        this.isLoading = true;

        const encoder = new TextEncoder();
        // await
        const item = TCBReceiptApi.Protobuf.PasswordMotify.create({
            id: this.storeUserInfo.storeUserId,
            oldPassword: encoder.encode(info.ori),
            oldE2eePd:await Encrypt.getE2EEpd(info.ori),
            newPassword: encoder.encode(info.new),
            newE2eePd: await Encrypt.getE2EEpd(info.new)
        });
        console.log(item);

        const passwordMotify = TCBReceiptApi.Protobuf.PasswordMotify.encode(item).finish();
        const errorCode = await StoreUserModel.changePassword(passwordMotify);
        console.log(errorCode);

        this.isChange = false;
        this.isResetPwd = false;
        if (errorCode !== TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
            this.isChange = true;
        } else {
            this.isResetPwd = true;
        }

        switch(errorCode) {
            case TCBReceiptApi.Protobuf.ErrorCode.EC_PASSWORD_LENGTH_ERROR:
                this.openHint("密碼不應少於六位");
                break;
            case TCBReceiptApi.Protobuf.ErrorCode.EC_PASSWORD_FORMAT_ERROR:
                this.openHint("密碼格式錯誤");
                break;
            case TCBReceiptApi.Protobuf.ErrorCode.EC_SAME_PASSWORD_ERROR:
                this.openHint("新密碼不得與原密碼相同");
                break;
            case TCBReceiptApi.Protobuf.ErrorCode.EC_OLD_PASSWORD_ERROR:
                this.openHint("原密碼錯誤");
                break;
            default:
                this.openHint(Common.ErrorCodeMap[errorCode]);
        }

        this.isLoading = false;
    }
    /* Reset pwd */

    /* Hint */
    private openHint(hint: string) {
        this.hintBox.show = true;
        this.hintBox.hint = hint;
    }

    private closeHint() {
        this.hintBox.show = false;
        this.hintBox.hint = "";

        const isAdmin = Cookies.get("isAdmin") as string;

        if (this.isDone) {
            if (isAdmin === undefined || isAdmin !== '1') {
                const goToEditPage = {
                    path: "/announcement/list",
                    // query: { user: '1' }
                };
                this.$router.push(goToEditPage);
            } else {
                this.$router.push("/store/user/list");
            }
        } else if (this.isChange) {
            this.lightboxResetPwd.show = true;
        } else if (this.isResetPwd) {
            if (isAdmin === '1' && this.storeUserInfo.type !== 4) { // 自己本身是用管理者帳號登入且修改其他種類帳號類型 => 重設密碼後不需要踢登出
                this.$router.push("/store/user/list");
            } else {
                this.$router.push("/login");
            }
        }
    }
    /* Hint */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);
        
        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        this.expireTime = Priv._getExpireTime();

        const isUser = parseInt(this.$route.query.user as string) as number;
        const userInfo: UserInfo = JSON.parse(Cookies.get("appUserInfo") as string);
        if (isUser !== 1 && !Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }  
        
        if (isUser === 1 && userInfo) {
            this.isUser = true;
            
            const item = TCBReceiptApi.Protobuf.FrontCredentials.create({
                account: userInfo.account as string,
                identification: userInfo.identification as string,
            });

            const frontCredentials = TCBReceiptApi.Protobuf.FrontCredentials.encode(item).finish();
            const [errorCode, storeUser] = await StoreUserModel.getStoreUserByAccountAndIdentification(frontCredentials);
            if (errorCode !== TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
                this.$router.push(DefaultPath);  // priv
            }
            console.log(storeUser);
            this.storeUserInfo = storeUser;
        }
    }
    /* 取得最新的權限map並判斷有何權限 */

    private putPermissionListInList() {
        this.storeUserInfo.permission = {};
        const permission: { [storeCode: string]: TCBReceiptApi.Protobuf.StoreUserPermissionList } = {}; // 帳號權限 - 以特店代號為索引的map

        this.groupPermissionList.forEach(groupItem => {
            const storeUserPermissionList = TCBReceiptApi.Protobuf.StoreUserPermissionList.create(); // 權限陣列
            groupItem.storeList.forEach(store => {
                if (store.selected) {
                    // 使用者選擇的特店資訊
                    const storeUserPermission = TCBReceiptApi.Protobuf.StoreUserPermission.create({
                        storeId: store.id as number,
                        storeCode: store.code as string,
                        tidNumber: groupItem.tidNumber as string,
                        registerName: store.name as string,
                    });
                    storeUserPermissionList.list.push(storeUserPermission);
                }
            });

            permission[groupItem.tidNumber] = storeUserPermissionList;
        });

        console.log("群組帳號權限");
        console.log(permission);
        this.storeUserInfo.permission = permission;
    }    
}
